<template>
	<div class="instafeed">
		<p class="username"><a :href="userpage"  target="_blank" >{{this.username}}</a></p>
		<a v-for="item in data" :key="item.id" :href="userpage"  target="_blank"  class="item">
			<div   class="img-wrapper" :style='{backgroundImage:`url(${item.images.standard_resolution.url })`}'>
			</div>
		</a>
	</div>
</template>

<script>
import axios from "axios";

export default {
	props:{
		accesstoken:{
			required:true,
			type:String
		},
		limit:{
			default:8,
			required:false,
			type: Number
		}
	},
	data() {
		return {
			url: "https://api.instagram.com/v1/users/self/media/recent/",
			data: [],
			error: false,
			username: ''
		}
	},
	computed: {
    	userpage() {
      		return 'https://www.instagram.com/' + this.username
		},
	
	},
	methods:{
		async getData(){
			await axios.get(
				//https://api.instagram.com/v1/self/media/recent?access_token=ACCESS_TOKEN
				`${this.url}?count=${this.limit}&access_token=${this.accesstoken}`
			).then(({data}) => {
				this.data = data.data
				this.username = this.data[0].user.username
			})
			.catch(function (error) {
				this.error = true
			});	
		}
	},
	created(){
		this.getData();
	}

}
</script>

<style lang="scss" scoped>


.instafeed{
	width: 100%;
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	grid-template-rows:  repeat(2, 1fr);
	grid-gap: 2px;
	margin-top: 60px;
	position: relative;
	@include res(tab-l){
		grid-template-rows: 1fr;
	}
	@include res(tab-p){
		grid-template-columns: repeat(2, 1fr);
		grid-template-rows:  repeat(2, 1fr);
	}
	 @include ie{
		display:-ms-flexbox;
		flex-wrap: wrap;
	}
	.item {
		 @include ie{
			width:25%;
		}
		.img-wrapper{
			width: 100%;
			height: 297px;
			background-position: center;
			background-size: cover;
			background-repeat: no-repeat;
			@include res(mobile){
				height: 150px
			}	
		}
		&:nth-of-type(4n), &:nth-of-type(4n-1) {
			position:relative;
			top: 60px;
			@include res(tab-l){
				display: none;
			}
		}
	}
	
	.username {
		position: absolute;
		font-size: 15px;
		letter-spacing: 2px;
		opacity: 0.5;
		right: 0;
		width: auto;
		&::before{
			content: '#';
		}
		@include res(tab-l){
			color: $white;
			top: 5px;
		}
		a, a:active, a:visited {
			color: $dark-grey;
			@include res(tab-l){
				color: $white;
				top: 5px;
			}
		}
		
	}
}
</style>
